<nts-string-text-box
    (keydown)="onKeyDown($event)"
    [tabIndex]="tabIndex"
    [propertyViewModel]="stringPropertyViewModel"
    [updateOnBlur]="!stringPropertyViewModel.instantModelChange"
    [placeholder]="propertyViewModel.metadataShortDescription"
    [showErrorBorder]="false"
    [showErrorTooltip]="false"
></nts-string-text-box>